import { useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import { ref, deleteObject } from 'firebase/storage'
import noImage from '../../assets/img/no-image.png'
import { setCurrentEntidade } from '../../provider/actions'
import { useProvider } from '../../provider/Provider'
import { Item } from './style'
import { Entidade } from '../../model/Entidade'
import EntidadeService from '../../services/EntidadeService'
import { storage } from '../../base'

export default function EntidadeItem2(props: {ent: Entidade}) {
    const { ent } = props
    const history = useHistory()
    const { dispatch, loadEntidades } = useProvider()

    const goToVisualizar = () => {
        setCurrentEntidade(dispatch, ent)
        setTimeout(() => {
            history.push(`/visualizar/${ent.id}`)
        }, 50)
    }

    const excluir = () => {
        swal(`Você confirma a exclusão da empresa ${ent.nome}?`, {
            dangerMode: true,
            buttons: ['Cancelar', 'Excluir']
        }).then((value) => {
            if (value) {
                EntidadeService.remove(ent.id!)
                    .then(() => {
                        const tempRef = ref(
                            storage, `${ent.logo}`
                        )
                        deleteObject(tempRef)
                        loadEntidades()
                        swal({
                            title: 'Empresa excluida com sucesso!',
                            icon: 'success',
                            buttons: [false],
                            timer: 2000
                        })
                    }).catch(() => {
                        swal({
                            title: 'Falha ao excluir empresa!',
                            icon: 'error',
                            buttons: [false],
                            timer: 2000
                        })
                    })
            }
        })
    }

    const editar = () => {
        setCurrentEntidade(dispatch, ent)
        history.push('/EditarEntidade')
    }

    return (
        <Item>
            <button
                className="item-header"
                onClick={goToVisualizar}
            >
                <img src={ent.logo || noImage} alt="Logo" />
            </button>
            <div className="item-content">
                <span>{ent.nome}</span>
                <div className="tags">
                    {
                        ent.tipoEntidade.map((a) => {
                            return (
                                <span key={a.id}>
                                    <i className="fas fa-tag fa-sm mr-1" />
                                    {a.nome}
                                </span>
                            )
                        })
                    }
                </div>
            </div>
            <div className="item-footer">
                <i onClick={editar} className="fas fa-edit" />
                <i onClick={excluir} className="fas fa-trash ml-2" />
                <i
                    onClick={goToVisualizar}
                    className="fas fa-file-search ml-2"
                />
            </div>
        </Item>
    )
}
